// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class NavUspCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()

    if (this.dataset?.autoplay === 'true') {
      this.interval = 0
      this.autoplay = (run, instance) => {
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          if (run && instance) {
            instance.next()
          }
        }, this.dataset.autoplayDuration)
      }
    }
    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return

    return new KeenSlider(this.els.slides.element, {
      duration: this.dataset.autoplayDuration,
      selector: this.els.slide.selector,
      drag: true,
      loop: this.dataset.autoplay,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'center',
        perView: 1,
        spacing: 10,
      },
      created: instance => {
        if (this.dataset?.autoplay !== 'true') return

        this.els.slides.element.addEventListener('mouseover', () => {
          this.autoplay(false, instance)
        })
        this.els.slides.element.addEventListener('mouseout', () => {
          this.autoplay(true, instance)
        })
        this.autoplay(true, instance)
      },
    })
  }
}

if (!customElements.get('nav-usp-carousel')) {
  customElements.define('nav-usp-carousel', NavUspCarousel)
}
